import { render, staticRenderFns } from "./layout-text.vue?vue&type=template&id=0c904a42&functional=true"
import script from "./layout-text.vue?vue&type=script&lang=js"
export * from "./layout-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c904a42')) {
      api.createRecord('0c904a42', component.options)
    } else {
      api.rerender('0c904a42', component.options)
    }
    module.hot.accept("./layout-text.vue?vue&type=template&id=0c904a42&functional=true", function () {
      api.rerender('0c904a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/layout/text/layout-text.vue"
export default component.exports